import api from '../../../app/axios';

const getChatFunnelConfig = async () => {
  const response = await api.get('/chatfunnel/admin/config');
  return response.data;
};

const updateChatFunnelConfig = async (data) => {
  const response = await api.put('/chatfunnel/admin/config', data);
  return response.data;
};

const getChatFunnelSummary = async () => {
  const response = await api.get('/chatfunnel/admin/summary');
  return response.data;
};

const getChatFunnelLeads = async (params) => {
  const response = await api.get('/chatfunnel/admin/leads', { params });
  return response.data;
};

const updateChatFunnelLead = async (leadId, data) => {
  const response = await api.patch(`/chatfunnel/admin/leads/${leadId}`, data);
  return response.data;
};

const getChatFunnelEvents = async (params) => {
  const response = await api.get('/chatfunnel/admin/events', { params });
  return response.data;
};

const getChatFunnelConflicts = async () => {
  const response = await api.get('/chatfunnel/admin/conflicts');
  return response.data;
};

const getChatFunnelContext = async (params) => {
  const response = await api.get('/chatfunnel/context', { params });
  return response.data;
};

const createChatFunnelLead = async (data) => {
  const response = await api.post('/chatfunnel/leads', data);
  return response.data;
};

const createChatFunnelEvent = async (data) => {
  const response = await api.post('/chatfunnel/events', data);
  return response.data;
};

const chatFunnelAdminService = {
  getChatFunnelConfig,
  updateChatFunnelConfig,
  getChatFunnelSummary,
  getChatFunnelLeads,
  updateChatFunnelLead,
  getChatFunnelEvents,
  getChatFunnelConflicts,
  getChatFunnelContext,
  createChatFunnelLead,
  createChatFunnelEvent,
};

export default chatFunnelAdminService;
